import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import * as Styles from './NameSegmentStep.styles';
import {
  Button, IconArrow, TextField,
} from 'gatorcomponents';

const NameSegmentStep = ({
  nameStepLocales,
  continueButtonClick,
  fieldNameValue,
  setFieldNameValue,
  fieldSegmentValue,
  setFieldSegmentValue,
  mobile,
}) => {
  const [displayAutoComplete, setDisplayAutoComplete] = useState(false);
  const [autoCompleteList, setAutoCompleteList] = useState(nameStepLocales.optionsList || []);

  const textFieldWrapperRef = useRef(null);

  const handleSetSegmentInputValue = (value) => {
    setFieldSegmentValue(value);
  };

  const handleSelectAutoCompleteOption = (value) => {
    handleSetSegmentInputValue(value);
    setDisplayAutoComplete(false);
  };

  const filterAutoCompleteList = useCallback((inputValue) => {
    if (!inputValue) {
      setAutoCompleteList(nameStepLocales.optionsList || []);
      return;
    }
    const filteredList = (nameStepLocales.optionsList || []).filter(item => item.label.toLowerCase().includes(inputValue.toLowerCase()));
    setAutoCompleteList(filteredList);
  }, [nameStepLocales]);

  useEffect(() => {
    filterAutoCompleteList(fieldSegmentValue);
  }, [fieldSegmentValue, filterAutoCompleteList]);

  const onChangeNameInput = (e) => {
    setFieldNameValue(e.target.value);
  };

  const onChangeInput = (e) => {
    handleSetSegmentInputValue(e.target.value);
  };

  const handleContinueButtonClick = () => {
    continueButtonClick && continueButtonClick();
  };

  const handleCloseAutoCompleteOnBlur = useCallback(() => {
    function handleClickOutside(event) {
      if (textFieldWrapperRef.current && !textFieldWrapperRef.current.contains(event.target)) {
        setDisplayAutoComplete(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    handleCloseAutoCompleteOnBlur();
  }, [handleCloseAutoCompleteOnBlur]);

  return (
    <Styles.Wrapper data-testid="ai-builder-create-site-name-step">
      <Styles.WrapperHeader>
        <Styles.Title>
          {nameStepLocales.title}
        </Styles.Title>
      </Styles.WrapperHeader>

      <Styles.Subtitle>
        {nameStepLocales.subtitle}
      </Styles.Subtitle>

      <Styles.WrapperForm>
        <Styles.WrapperInput>
          <Styles.Label>{nameStepLocales.inputNameHeadText}</Styles.Label>

          <TextField
            label={nameStepLocales.inputNamePlaceholder}
            onChange={onChangeNameInput}
            value={fieldNameValue}
            maxLength={60}
            testId="name-step-name-field"
          />
        </Styles.WrapperInput>

        <Styles.WrapperInput>
          <Styles.Label>{nameStepLocales.inputSegmentHeadText}</Styles.Label>

          <Styles.TextFieldWrapper ref={textFieldWrapperRef}>
            <TextField
              testId="segment-step-input-field"
              leadingIcon={!mobile && 'IconSearch'}
              label={nameStepLocales.inputSegmentPlaceholder}
              onChange={onChangeInput}
              value={fieldSegmentValue}
              onFocusInput={() => setDisplayAutoComplete(true)}
              autoComplete="off"
              maxLength={60}
            />

            {displayAutoComplete && (
              <Styles.AutoComplete>
                {autoCompleteList.map(item => (
                  <Styles.AutoCompleteItem
                    key={item.value}
                    isSelected={fieldSegmentValue === item.label}
                    onClick={() => handleSelectAutoCompleteOption(item.label)}
                    role="button"
                  >
                    {item.label}
                  </Styles.AutoCompleteItem>
                ))}
              </Styles.AutoComplete>
            )}
          </Styles.TextFieldWrapper>
        </Styles.WrapperInput>
      </Styles.WrapperForm>

      <Styles.ButtonWrapper>
        <Button
          testId="name-step-continue-button"
          label={nameStepLocales.buttonLabel}
          width={mobile ? 'full' : 'fit'}
          size="large"
          onClick={handleContinueButtonClick}
          disabled={!fieldNameValue || !fieldSegmentValue}
          iconRight={
            <IconArrow direction="right" />
          }
        />
      </Styles.ButtonWrapper>
    </Styles.Wrapper>
  );
};

export default NameSegmentStep;
